import { combineReducers } from "redux";
import reduceReducers from "reduce-reducers";
import { createBrowserHistory } from "history";
import { connectRouter } from "connected-react-router";

import { sessionActions } from "../actions";
import { initialState } from "../initialState";
import { createReducer } from "./utilities";

import { sessionReducer } from "./session.reducer";
import { imageReducer } from "./image.reducer";
import { nationReducer } from "./nation.reducer";
import { numberReducer } from "./number.reducer";
import { bannerReducer } from "./banner.reducer";
import { fileReducer } from "./file.reducer";
import { activityReducer } from "./activity.reducer";
import { videoReducer } from "./video.reducer";
import { tagReducer } from "./tag.reducer";

const browserHistory = createBrowserHistory();

const rootReducer = combineReducers({
  session: sessionReducer,
  image: imageReducer,
  file: fileReducer,
  nation: nationReducer,
  number: numberReducer,
  banner: bannerReducer,
  router: connectRouter(browserHistory),
  activity: activityReducer,
  video: videoReducer,
  tag: tagReducer,
});

const globalReducer = createReducer(initialState, {
  [sessionActions.LOGOUT]: () => initialState,
});

export default reduceReducers(initialState, rootReducer, globalReducer);
